export const joinStyles = (styles: string[]): string => {
  return styles.join(' ');
};
export const toCamelCase= (str: string | undefined)=>{
  return str?.toLowerCase().split(" ").map((word,index)=>{
    if(index===0) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  })
    .join("");
}
